export default __webpack_public_path__ + "static/media/Annual.0a022c22.jpg";